// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__nqBu4","inner":"Layout_inner__rjdfA","content":"Layout_content__UOgH6","content_box":"Layout_content_box__AaWI7","icon":"Layout_icon__lHC3R"};